import {Route} from "@angular/router";
import {ForwardMappComponent} from "../shared/elements/forward-mapp.component";
import {forwardMappGuard} from "../shared/guards/forward-mapp.guard";


export const knowledgebaseCompatabilityRoutes: Route[] = [
  {
      path: 'mapp/list/:param1/:param2',
      component: ForwardMappComponent,
      canActivate: [forwardMappGuard]
    },
    {
      path: 'mapp/list/:param1/:param2/:param3',
      component: ForwardMappComponent,
      canActivate: [forwardMappGuard]
    },
]